import axios from 'axios';

// API URL'i - production'da environment variable, development'da localhost
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // Render.com için timeout artırıldı
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - token'ı otomatik ekle
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - token süresi dolmuşsa otomatik logout
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      window.location.href = '/admin-login';
    }
    return Promise.reject(error);
  }
);

export const propertyAPI = {
  // Tüm ilanları getir
  getAll: () => api.get('/properties'),
  
  // Tek ilan getir
  getById: (id) => api.get(`/properties/${id}`),
  
  // Yeni ilan ekle
  create: (propertyData) => {
    const formData = new FormData();
    
    // Metin verilerini ekle
    Object.keys(propertyData).forEach(key => {
      if (key !== 'images') {
        formData.append(key, propertyData[key]);
      }
    });
    
    // Resimleri ekle
    if (propertyData.images && propertyData.images.length > 0) {
      Array.from(propertyData.images).forEach(image => {
        formData.append('images', image);
      });
    }
    
    return api.post('/properties', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  // İlan güncelle
  update: (id, propertyData) => {
    const formData = new FormData();
    
    Object.keys(propertyData).forEach(key => {
      if (key !== 'images') {
        formData.append(key, propertyData[key]);
      }
    });
    
    if (propertyData.images && propertyData.images.length > 0) {
      Array.from(propertyData.images).forEach(image => {
        formData.append('images', image);
      });
    }
    
    return api.put(`/properties/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  // İlan sil
  delete: (id) => api.delete(`/properties/${id}`),
  
  // İlanı öne çıkar/çıkarma
  toggleFeatured: (id) => api.patch(`/properties/${id}/featured`),
  
  // Admin: Tüm ilanları getir
  getAdminAll: () => api.get('/properties/admin/all'),
};

// Auth API
export const authAPI = {
  // Login
  login: (credentials) => api.post('/auth/login', credentials),
  
  // Token doğrulama
  verify: (token) => api.post('/auth/verify', { token }),
  
  // Logout
  logout: () => api.post('/auth/logout')
};

export default api;